// extracted by mini-css-extract-plugin
export default {"wrapper":"WidgetActionButtons_wrapper__Jqhlx","button":"WidgetActionButtons_button__UA96w"};